import Header from "../Components/Header";
import Hero from "../Components/Hero";
import TrendingProducts from "../Components/TrendingProducts";
import Videosection from "../Components/Videosection";
import Believe from "../Components/Believe";
import Footer from "../Components/Footer";
import Faqsection from "../Components/Faqsection";

function Home() {
  return (
    <>
      <main className="container-fluid">
        <Header />
        <Hero />
        <TrendingProducts />
        {/* <ReviewSlider/>  */}
        <Videosection />
        <Believe />
        <Faqsection />
        <Footer />
      </main>
    </>
  );
}

export default Home;
